<template>
    <div class="buyNowButtonMain" ref="buyNowButton">
        <BuyNow :ifShow.sync="ifShowBuyNowDialog" :shopInfo="buyNowShopInfo" />
        
        <button @click="buyNow" :style="`opacity: ${ keepPress ? 1 : 0.6 }`">现场买单</button>
    </div>
</template>

<script>

import BuyNow from "@/components/common/BuyNow.vue";

let buyNowButtonWidth = 0;
let buyNowButtonHeight = 0;

export default {
    name: 'BuyNowButton',

    components: {
        BuyNow,
    },

    props: {
        shopInfo: {
            required: true,
            type: Object,
        }
    },

    computed: {
        buyNowShopInfo() {
            return Object.assign(this.shopInfo, {
                supplierInfo: {
                    name: this.shopInfo.shopNickname,
                },
            })
        },
    },

    data() {
        return {
            keepPress: false,

            ifShowBuyNowDialog: false,
        }
    },

    mounted() {
        const buyNowButtonClientRect = this.$refs.buyNowButton.getClientRects()[0];
        buyNowButtonWidth = buyNowButtonClientRect.width;
        buyNowButtonHeight = buyNowButtonClientRect.height;

        //
        this.$refs.buyNowButton.addEventListener(
            'touchstart',
            (e) => {
                //
                e.stopPropagation()

                //
                this.start(e)
            },
            {
                capture: true,
            }
        )

        this.$refs.buyNowButton.addEventListener(
            'touchend',
            (e) => {
                //
                e.stopPropagation()

                //
                this.end(e)
            },
            {
                capture: true,
            }
        )

        this.$refs.buyNowButton.addEventListener(
            'touchmove',
            (e) => {
                //
                e.stopPropagation()
                e.preventDefault()

                //
                this.move(e)
            },
            {
                capture: true,
            }
        )
    },

    methods: {
        buyNow()
        {
            this.ifShowBuyNowDialog = true;
        },

        start() {
            this.keepPress = false

            //
            this.keepPressTimeout = setTimeout(() => {
                this.keepPress = true
            }, 100)
        },

        end() {
            //
            clearTimeout(this.keepPressTimeout)

            // keepPress
            this.keepPress = false;

            //
            if(this.$refs.buyNowButton.getClientRects()[0].left + buyNowButtonWidth / 2 < window.screen.width / 2)
            {
                this.$refs.buyNowButton.style.transition = 'left 0.5s';
                this.$refs.buyNowButton.style.left = '0px';
            }
            else
            {
                this.$refs.buyNowButton.style.transition = 'left 0.5s';
                this.$refs.buyNowButton.style.left = `${window.screen.width - buyNowButtonWidth}px`;
            }

            setTimeout(() => {
                this.$refs.buyNowButton.style.transition = 'none'
            }, 550);
        },

        move(e) {
            if(this.keepPress == false)
            {
                return;
            }

            //
            let top = e.changedTouches[0].pageY - buyNowButtonHeight / 2;
            let left = e.changedTouches[0].pageX - buyNowButtonWidth / 2;

            //
            if(top < 0)
            {
                top = 0;
            }
            if(top > window.screen.height - buyNowButtonWidth)
            {
                top = window.screen.height - buyNowButtonWidth;
            }

            //
            if(left < 0)
            {
                left = 0;
            }
            if(left > window.screen.width - buyNowButtonWidth)
            {
                left = window.screen.width - buyNowButtonWidth;
            }

            //
            this.$refs.buyNowButton.style.top = top + "px"
            this.$refs.buyNowButton.style.left = left + "px"
        },
    },
}
</script>

<style lang="scss" scoped>

.buyNowButtonMain {
    position: fixed;
    z-index: 101;
    right: 0;
    top: 1.32rem;
    font-size: $fontSizeContent;

    button {
        opacity: 0.6;
        font-size: 0.2rem;
    }
}

</style>